import type { ApiResponse, CrmUser } from '@/models/api'
import { api, readData } from '@/services/apiClient'

export async function loadUsers(): Promise<CrmUser[]> {
  const { data } = await api.get<ApiResponse<CrmUser[]>>('/users')
  return readData(data, [])
}

export async function saveUser(input: {
  userId?: string | null
  emailAddress: string
  fullName: string
  role: number
  enabled: boolean
  password?: string
}): Promise<void> {
  const { data } = await api.post<ApiResponse<string>>('/users', input)
  readData(data, '')
}

export async function removeUser(userId: string): Promise<void> {
  const { data } = await api.delete<ApiResponse<null>>(`/users/${userId}`)
  readData(data, null)
}

export async function lockUser(userId: string): Promise<void> {
  const { data } = await api.post<ApiResponse<null>>(`/users/${userId}/lock`)
  readData(data, null)
}

export async function reassignUserWork(fromUserId: string, toUserId: string): Promise<void> {
  const { data } = await api.post<ApiResponse<null>>('/users/reassign', { fromUserId, toUserId })
  readData(data, null)
}

export async function inviteUser(input: { email: string; name: string; role: number }): Promise<void> {
  const { data } = await api.post<ApiResponse<null>>('/users/invitations', input)
  readData(data, null)
}
